
import { format, isSameMonth } from 'date-fns';
import { es } from 'date-fns/locale';

interface CalendarMonthProps {
  monthDate: Date;
  days: Date[];
  onDateClick: (date: Date) => void;
  getDayClassName: (day: Date, isCurrentMonth: boolean) => string;
  isDateUnavailable: (date: Date) => boolean;
}

const CalendarMonth = ({ 
  monthDate, 
  days, 
  onDateClick, 
  getDayClassName, 
  isDateUnavailable 
}: CalendarMonthProps) => {
  return (
    <div className="flex-1">
      <h3 className="text-lg font-semibold text-center mb-4">
        {format(monthDate, 'MMMM yyyy', { locale: es })}
      </h3>
      
      <div className="grid grid-cols-7 gap-1 mb-2">
        {['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'].map(day => (
          <div key={day} className="text-center text-sm font-medium text-gray-500 py-2">
            {day}
          </div>
        ))}
      </div>

      <div className="grid grid-cols-7 gap-1">
        {days.map((day, index) => {
          const isCurrentMonth = isSameMonth(day, monthDate);
          
          return (
            <button
              key={index}
              onClick={() => onDateClick(day)}
              disabled={isDateUnavailable(day) || !isCurrentMonth}
              className={getDayClassName(day, isCurrentMonth)}
            >
              {format(day, 'd')}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CalendarMonth;
